import { createGlobalStyle } from 'styled-components';
import { CssSwiper } from '../components/swiper/swiper.style';
import { CssVars } from './global.vars';
import { CssA11y } from './styles/a11y';
import { CssBase } from './styles/base';
import { CssDebug } from './styles/debug';
import { CssPrint } from './styles/print';
import { CssReset } from './styles/reset';
import { CssScrollbar } from './styles/scrollbar';
import { CssTypography } from './styles/typography';

export const GlobalStyle = createGlobalStyle`
  ${CssReset}
  ${CssVars}
  ${CssBase}
  ${CssA11y}
  ${CssTypography}
  ${CssScrollbar}
  ${CssPrint}
  ${CssDebug}
  ${CssSwiper}
`;
